<template>
  <div class="betting-bot">
    <div class="betting-bot-dropdowns">
      <div class="input-containers">
        <div class="dropdown-container dropdown-container--left">
          <div class="dropdown-container-label">
            <span>{{$t(`trader.bettingBot.sport`) | removeDiacriticsFromUppercase}}</span>
          </div>
          <div class="dropdown-wrapper">
            <div @click="showDropdown('dropdownSports')"
                  class="dropdown">
              <div class="dropdown-selection" v-if="selectedSportData">
                <!--            <div class="dropdown-icon">-->
                <!--              <img :src="sportsToIconsMapping.basketball">-->
                <!--            </div>-->
                <div class="dropdown-text">
                  <span>{{$t(`sports.${selectedSportData.sportIdentifier}`)}}</span>
                </div>
              </div>
              <div
                v-bind:class="{'dropdown-dropdown-arrow-open':dropdowns['dropdownSports']}"
                class="dropdown-dropdown-arrow">
                <v-icon>
                  krypt-arrow-down
                </v-icon>
              </div>
            </div>
            <div class="dropdown-anchor">
              <div v-bind:class="{'dropdown-absolute-open':dropdowns['dropdownSports']}"
                    class="dropdown-absolute dropdown-absolute-sports"
                    v-click-outside:dropdownSports="closeDropdown.bind(closeDropdown,'dropdownSports')">
                <div v-bind:class="{'dropdown-contents-open':dropdowns['dropdownSports']}"
                      class="dropdown-contents">

                  <div v-for="sport in sportsList"
                        class="dropdown-item"
                        @click="closeDropdown('dropdownSports')">
                    <div class="dropdown-item-selection" @click="selectSport(sport)">
                      <!--                  <div class="dropdown-item-icon">-->
                      <!--                    <img :src="sportsToIconsMapping[sport.sportIdentifier]"></img>-->
                      <!--                  </div>-->
                      <div class="dropdown-item-text">
                        <span>{{$t(`sports.${sport.sportIdentifier}`)}}</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dropdown-container dropdown-container--right">
          <div class="dropdown-container-label">
            <span>{{$t(`trader.bettingBot.category` ) | removeDiacriticsFromUppercase}}</span>
          </div>
          <div class="dropdown-wrapper">
            <div @click="showDropdown('dropdownCategory')"
                  class="dropdown">
              <div class="dropdown-selection" v-if="selectedCategoryData">
                <div class="dropdown-text">
                  <span>{{selectedCategoryData.name}}</span>
                </div>
              </div>
              <div
                v-bind:class="{'dropdown-dropdown-arrow-open':dropdowns['dropdownCategory']}"
                class="dropdown-dropdown-arrow">
                <v-icon>
                  krypt-arrow-down
                </v-icon>
              </div>
            </div>
            <div class="dropdown-anchor">
              <div v-bind:class="{'dropdown-absolute-open':dropdowns['dropdownCategory']}"
                    v-click-outside:dropdownCategory="closeDropdown.bind(closeDropdown,'dropdownCategory')"
                    class="dropdown-absolute dropdown-absolute-category">
                <div v-bind:class="{'dropdown-contents-open':dropdowns['dropdownCategory']}"
                      class="dropdown-contents">

                  <div v-for="category in categoriesList"
                        class="dropdown-item"
                        @click="closeDropdown('dropdownCategory')">
                    <div class="dropdown-item-selection" @click="selectCategory(category)">
                      <div class="dropdown-item-text">
                        <span>{{category.name}}</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dropdown-container">
        <div class="dropdown-container-label">
          <span>{{$t(`trader.bettingBot.competition`) | removeDiacriticsFromUppercase}}</span>
        </div>
        <div class="dropdown-wrapper">
          <div @click="showDropdown('dropdownCompetition')"
                class="dropdown">
            <div class="dropdown-selection" v-if="selectedTournamentData">
              <div class="dropdown-text">
                <span>{{selectedTournamentData.name}}</span>
              </div>
            </div>
            <div
              v-bind:class="{'dropdown-dropdown-arrow-open':dropdowns['dropdownCompetition']}"
              class="dropdown-dropdown-arrow">
              <v-icon>
                krypt-arrow-down
              </v-icon>
            </div>
          </div>
          <div class="dropdown-anchor">
            <div v-bind:class="{'dropdown-absolute-open':dropdowns['dropdownCompetition']}"
                  v-click-outside:dropdownCompetition="closeDropdown.bind(closeDropdown,'dropdownCompetition')"
                  class="dropdown-absolute dropdown-absolute-competition">
              <div v-bind:class="{'dropdown-contents-open':dropdowns['dropdownCompetition']}"
                    class="dropdown-contents">

                <div v-for="tournament in tournamentsList"
                      class="dropdown-item"
                      @click="closeDropdown('dropdownCompetition')">
                  <div class="dropdown-item-selection" @click="selectTournament(tournament)">
                    <div class="dropdown-item-text">
                      <span>{{tournament.name}}</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dropdown-container">
        <div class="dropdown-container-label">
          <span>{{$t(`trader.bettingBot.market`)| removeDiacriticsFromUppercase}}</span>
        </div>
        <div class="dropdown-wrapper">
          <div @click="showDropdown('dropdownMarket')"
                class="dropdown">
            <div class="dropdown-selection" v-if="selectedMarket">
              <div class="dropdown-text">
                <span>{{selectedMarket !=='none'?selectedMarket.name : $t('trader.bettingBot.none')}}</span>
              </div>
            </div>
            <div
              v-bind:class="{'dropdown-dropdown-arrow-open':dropdowns['dropdownMarket']}"
              class="dropdown-dropdown-arrow">
              <v-icon>
                krypt-arrow-down
              </v-icon>
            </div>
          </div>
          <div class="dropdown-anchor">
            <div v-bind:class="{'dropdown-absolute-open':dropdowns['dropdownMarket']}"
                  v-click-outside:dropdownMarket="closeDropdown.bind(closeDropdown,'dropdownMarket')"
                  class="dropdown-absolute dropdown-absolute-market">
              <div v-bind:class="{'dropdown-contents-open':dropdowns['dropdownMarket']}"
                    class="dropdown-contents">

                <div v-for="market in marketsList"
                      class="dropdown-item"
                      @click="closeDropdown('dropdownMarket')">
                  <div class="dropdown-item-selection" @click="selectMarket(market)">
                    <div class="dropdown-item-text">
                      <span>{{market !=='none'?market.name : $t('trader.bettingBot.none')}}</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="empty-betslip" v-if="selectedMarket === '' || selectedMarket === 'none'">

      <div class="empty-betslip-text">
        <span>{{$t('trader.bettingBot.noBotSelected')}}</span>
      </div>
    </div>
    <div class="betting-bot-options" v-if="selectedMarket !== '' && selectedMarket !== 'none'">
      <div class="state-container">
        <div class="betting-bot-state">
          <input class="betting-bot-checkbox" type="checkbox"
                 v-model="tempBotConfig.botActive">
          <div class="visible-betting-bot-checkbox">
            <v-icon>krypt-success</v-icon>
          </div>
          <span>{{$t(`trader.bettingBot.active`)}}</span>
        </div>
      </div>

      <div class="input-containers">
        <div class="input-container input-container-dual-left">
          <div class="input-label">
            <span>{{$t(`trader.bettingBot.seed`) | removeDiacriticsFromUppercase}}</span>
          </div>
          <div class="input-wrapper">
            <input class="input-inner" type="text" :value="tempBotConfig.botSeed "
                   v-on:input="validateLargeNumberWithDecimals($event,'botSeed')">
          </div>
        </div>
        <div class="input-container input-container-dual-right">
          <div class="input-label">
            <span>{{$t(`trader.bettingBot.margin`) | removeDiacriticsFromUppercase}}</span>
          </div>
          <div class="input-wrapper">
            <input class="input-inner" type="text" :value="tempBotConfig.margin"
                   v-on:input="validateLargeNumberWithDecimals($event,'margin')">
          </div>
        </div>
      </div>
      <div class="input-containers">
        <div class="input-container input-container-dual-left">
          <div class="input-label">
            <span
              v-html="this.$options.filters.removeDiacriticsFromUppercase(this.$t(`trader.bettingBot.maxLoss`))"></span>
          </div>
          <div class="input-wrapper">
            <input class="input-inner" type="text"
                   v-on:input="validateLargeNumberWithDecimals($event,'maxLoss')"
                   :value="tempBotConfig.maxLoss">
          </div>
        </div>
        <div class="input-container input-container-dual-right">
          <div class="input-label">
            <span
              v-html="this.$options.filters.removeDiacriticsFromUppercase(this.$t(`trader.bettingBot.liquidityPerEvent`))"></span>
          </div>
          <div class="input-wrapper">
            <input class="input-inner" type="text"
                   v-on:input="validateLargeNumberWithDecimals($event,'maxStake')"
                   :value="tempBotConfig.maxStake ">
          </div>
        </div>
      </div>
      <div class="input-containers">
        <div class="input-container input-container-dual-left">
          <div class="input-label">
            <span
              v-html="this.$options.filters.removeDiacriticsFromUppercase(this.$t(`trader.bettingBot.inPlayDelay`))"></span>
          </div>
          <div class="input-wrapper">
            <input class="input-inner" type="text" :value="tempBotConfig.delay"
                   v-on:input="validateIntegerNumber($event,'delay')">
          </div>
        </div>
        <div class="input-container input-container-dual-right">
          <div class="input-label">
            <span v-html="this.$options.filters.removeDiacriticsFromUppercase(this.$t(`trader.bettingBot.autoAdjustLadder`))"></span>
          </div>
          <div class="input-wrapper">
            <input class="input-inner" type="text" :value="tempBotConfig.ladderStepOnMatch"
                   v-on:input="validateIntegerNumber($event,'ladderStepOnMatch')">
          </div>
        </div>
      </div>
      <div class="input-containers input-containers--align-left">
        <div class="betting-bot-state">
          <input class="betting-bot-checkbox" type="checkbox"
                 v-model="applyDelayToAllCompetitions">
          <div class="visible-betting-bot-checkbox">
            <v-icon>krypt-success</v-icon>
          </div>
          <span>{{$t(`trader.bettingBot.applyDelay`)}}</span>
        </div>

      </div>
      <div class="read-only-containers">
        <div class="read-only-container read-only-container--left">
          <div class="read-only-label">
            <span>{{$t(`trader.bettingBot.openPosition`) | removeDiacriticsFromUppercase}}</span>
          </div>
          <div class="read-only-wrapper">
            <div class="read-only-inner" type="text">
              <span v-bind:class="{
            'positive-open-position':selectedMarket.botOpenPosition > 0,
            'negative-open-position':selectedMarket.botOpenPosition < 0,
            }">{{selectedMarket.botOpenPosition | numberWithCommas}}</span>
            </div>
          </div>
        </div>
        <div class="read-only-container read-only-container--right">
          <div class="read-only-label">
            <span>{{$t(`trader.bettingBot.remainingPosition`) | removeDiacriticsFromUppercase}}</span>
          </div>
          <div class="read-only-wrapper">
            <div class="read-only-inner" type="text"
            >
              <span v-bind:class="{
            'reduced-seed':(seedPercent >= 0.05 && seedPercent < 0.2)  ,
            'very-low-seed':(seedPercent < 0.05 ),
            }">{{selectedMarket.botSeedRemaining | numberWithCommas}}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="place-bet-container">

      <div class="place-bet-amount-controls">
        <div class="close-button" @click="closeBot"
             v-bind:class="{'close-button--disabled':false }">
          <span>{{ $t('trader.bettingBot.close') |
            removeDiacriticsFromUppercase}}</span>
        </div>
        <div class="footer-button-wrapper">
          <div @click="resetBot" class="footer-button footer-button--grey"
               v-bind:class="{'footer-button-spinning':false}">
            <v-icon v-show="false">krypt-loader</v-icon>
            <span v-bind:class="{'footer-button-text':false}">{{ $t('trader.bettingBot.resetBot') |
              removeDiacriticsFromUppercase}}</span>
          </div>
        </div>
        <div class="footer-button-wrapper">
          <div @click="updateBot" class="footer-button footer-button--primary"
               v-bind:class="{'footer-button-spinning':false}">
            <v-icon v-show="false">krypt-loader</v-icon>
            <span v-bind:class="{'footer-button-text':false}">{{ $t('trader.bettingBot.update') |
              removeDiacriticsFromUppercase}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import BasketBallIcon from '@/assets/Sports/Basketball.svg';
import SoccerIcon from '@/assets/Sports/Soccer.svg';
import TableTennis from '@/assets/Sports/Ping-Pong.svg';
import TennisIcon from '@/assets/Sports/Tennis.svg';
import CricketIcon from '@/assets/Sports/Cricket.svg';

//Prefetch iamges
const BasketBallIconObj = new Image();
BasketBallIconObj.src = BasketBallIcon;
const SoccerIconObj = new Image();
SoccerIconObj.src = SoccerIcon;
const TableTennisObj = new Image();
TableTennisObj.src = TableTennis;
const TennisIconObj = new Image();
TennisIconObj.src = TennisIcon;
const CricketIconObj = new Image();
CricketIconObj.src = CricketIcon;

export default {
  name: 'BettingBot',
  data: function () {
    return {
      isBotActive: false,
      dropdowns: {
        dropdownSports: false,
        dropdownCategory: false,
        dropdownCompetition: false,
        dropdownMarket: false
      },
      sportsToIconsMapping: {
        soccer: SoccerIconObj.src,
        tennis: TennisIconObj.src,
        basketball: BasketBallIconObj.src,
        tabletennis: TableTennisObj.src,
        cricket: CricketIconObj.src,
      },
      _clickOutside: {
        dropdownSports: null,
        dropdownCategory: null,
        dropdownCompetition: null,
        dropdownMarket: null
      },
      tempBotConfig: {
        'id': 0,
        'name': '',
        'main': false,
        'orderId': 0,
        'delay': 0,
        'margin': 0,
        'ladderStepOnMatch': 0,
        'commission': 0,
        'botActive': false,
        'maxStake': 0,
        'maxLoss': 0,
        'botSeed': 0,
        'botOpenPosition': 0,
        'botPnL': 0,
        'botSeedRemaining': 0,
        'botStopped': false
      },
      applyDelayToAllCompetitions: false
    };
  },
  computed: {
    shouldResetFlags: function () {
      return this.$store.state.trader.bettingBot.bettingBotResetFlags;
    },
    userCurrency: function () {
      return this.$store.state.userCurrency;
    },
    selectedSport: function () {
      return this.$store.state.trader.bettingBot.selectedSport;
    },
    selectedCategory: function () {
      return this.$store.state.trader.bettingBot.selectedCategory;
    },
    selectedTournament: function () {
      return this.$store.state.trader.bettingBot.selectedTournament;
    },
    selectedSportData: function () {
      return this.$store.state.trader.bettingBot
        ?.supportedSportsMap[this.$store.state.trader.bettingBot.selectedSport];
    },
    selectedCategoryData: function () {
      return this.$store.state.trader.bettingBot
        ?.supportedSportsMap[this.$store.state.trader.bettingBot.selectedSport]
        ?.supportedCategoriesMap[this.$store.state.trader.bettingBot.selectedCategory];
    },
    selectedTournamentData: function () {
      return this.$store.state.trader.bettingBot
        ?.supportedSportsMap[this.$store.state.trader.bettingBot.selectedSport]
        ?.supportedCategoriesMap[this.$store.state.trader.bettingBot.selectedCategory]
        ?.supportedTournamentsMap[this.$store.state.trader.bettingBot.selectedTournament];
    },
    selectedMarket: function () {
      return this.$store.state.trader.bettingBot.selectedMarket;
    },
    sportsList: function () {
      return this.$store.state.trader.bettingBot.supportedSports.map(function (sportData) {
        let sportDataLocalised = sportData;
        sportData.name = this.$t(`sports.${sportData.sportIdentifier}`);
        return sportDataLocalised;
      }.bind(this))
        .sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
    },
    categoriesList: function () {
      return this.$store.state.trader.bettingBot.supportedSportsMap[this.$store.state.trader.bettingBot.selectedSport]?.supportedCategories;
    },
    tournamentsList: function () {
      return this.$store.state.trader.bettingBot
        .supportedSportsMap[this.$store.state.trader.bettingBot.selectedSport]
        ?.supportedCategoriesMap[this.$store.state.trader.bettingBot.selectedCategory]?.supportedTournaments;

    },
    marketsList: function () {
      return ['none'].concat(Object.values(this.$store.state.trader.bettingBot.marketsForBot).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      }));
    },
    seedPercent: function () {
      /* this calculation is wrong and will always return > 1
      return Math.trunc(this.selectedMarket.botSeed / this.selectedMarket.botSeedRemaining); */
      return this.selectedMarket.botSeed > 0 ? (this.selectedMarket.botSeedRemaining / this.selectedMarket.botSeed) : -1;
    }
  },
  watch: {
    shouldResetFlags: function (newValue, oldValue) {
      if (newValue === true) {
        this.applyDelayToAllCompetitions = false;
        this.$store.commit('setBettingBotResetFlags', false);
      }
    },

    selectedMarket: function (newMarketConfig, oldMarketConfig) {
      if (newMarketConfig.id !== oldMarketConfig.id) {
        this.applyDelayToAllCompetitions = false;
        this.tempBotConfig = JSON.parse(JSON.stringify(newMarketConfig));
        this.tempBotConfig.botSeed = this.$options.filters.fillNumberWithZeroes(this.tempBotConfig.botSeed);
        this.tempBotConfig.maxStake = this.$options.filters.fillNumberWithZeroes(this.tempBotConfig.maxStake);
        this.tempBotConfig.maxLoss = this.$options.filters.fillNumberWithZeroes(this.tempBotConfig.maxLoss);
      }
    }
  },
  methods: {
    validateIntegerNumber: function (event, field) {
      event.currentTarget.value = this.processIntegerInputNumber(event.target.value, event.target.selectionStart);
      this.tempBotConfig[field] = event.currentTarget.value;
    },
    validateLargeNumberWithDecimals: function (event, field) {
      event.currentTarget.value = this.processLargeNumberWithDecimalsInputNumber(event.target.value, event.target.selectionStart);
      this.tempBotConfig[field] = event.currentTarget.value;
      // this.stakeValue = this.$options.filters.fillNumberWithZeroes(this.stakeValue);
    },
    validateSmallNumberWithDecimals: function (event, field) {
      event.currentTarget.value = this.processSmallNumberWithDecimalsInputNumber(event.target.value, event.target.selectionStart);
      this.tempBotConfig[field] = event.currentTarget.value;
      // this.stakeValue = this.$options.filters.fillNumberWithZeroes(this.stakeValue);
    },
    processLargeNumberWithDecimalsInputNumber: function (value, selectionStart) {
      let regExp = new RegExp('(\\d{0,7})?([.|,]{1}(\\d{0,2}))?');
      let purifiedValue = value.match(regExp)[0].replace(',', '.');
      return (purifiedValue.startsWith('00') && (purifiedValue = purifiedValue.slice(2)),
      purifiedValue.startsWith('.') && selectionStart && (purifiedValue = '0' + purifiedValue),
        purifiedValue);
    },
    processSmallNumberWithDecimalsInputNumber: function (value, selectionStart) {
      let regExp = new RegExp('(\\d{0,2})?([.|,]{1}(\\d{0,2}))?');
      let purifiedValue = value.match(regExp)[0].replace(',', '.');
      return (purifiedValue.startsWith('00') && (purifiedValue = purifiedValue.slice(2)),
      purifiedValue.startsWith('.') && selectionStart && (purifiedValue = '0' + purifiedValue),
        purifiedValue);
    },
    processIntegerInputNumber: function (value, selectionStart) {
      let regExp = new RegExp('(\\d{0,2})?');
      let purifiedValue = value.match(regExp)[0].replace(',', '.');
      return (purifiedValue.startsWith('00') && (purifiedValue = purifiedValue.slice(2)),
      purifiedValue.startsWith('.') && selectionStart && (purifiedValue = '0' + purifiedValue),
        purifiedValue);
    },
    closeBot: function (payload) {
      /* removed because after closing the configuration, it reloads the bot configuration
      this.$store.dispatch('getMarketBotConfig', this.selectedMarket.id); */
      this.$store.commit('setBotConfig', 'none');

    },
    resetBot: function () {
      if (this.selectedMarket) {
        this.$store.dispatch('resetBot', {
          marketId: this.selectedMarket.id,
          tournamentId: this.selectedTournamentData.id
        });
      }
    },
    updateBot: function () {
      if (this.selectedMarket) {
        if (Number(this.tempBotConfig.maxLoss) > Number(this.tempBotConfig.botSeed)) {
          this.$store.commit('setBettingBotMessage', {
            type: 'error',
            messageId: 'BetError',
            message: this.$i18n.t('trader.bettingBot.maxLossError'),
            messagePersistence: 'temporaryOnClickRemove'

          });
        } else if (Number(this.tempBotConfig.maxStake) > Number(this.tempBotConfig.maxLoss)) {
          this.$store.commit('setBettingBotMessage', {
            type: 'error',
            messageId: 'BetError',
            message: this.$i18n.t('trader.bettingBot.liquidityError'),
            messagePersistence: 'temporaryOnClickRemove'

          });
        } else {
          this.$store.dispatch('updateBot',
            {
              'tournament': this.selectedTournamentData.id,
              'id': this.tempBotConfig.id,
              'margin': this.tempBotConfig.margin,
              'seed': this.tempBotConfig.botSeed,
              'maxStake': this.tempBotConfig.maxStake,
              'maxLoss': this.tempBotConfig.maxLoss,
              'active': this.tempBotConfig.botActive,
              'ladderStepOnMatch': this.tempBotConfig.ladderStepOnMatch,
              'delay': this.tempBotConfig.delay,
              'applyDelayToAllTournaments': this.applyDelayToAllCompetitions
            });

        }
      }
    },
    showDropdown: function (dropdown) {
      this.dropdowns[dropdown] = true;
    },
    closeDropdown: function (dropdown) {
      this.dropdowns[dropdown] = false;
    },
    selectSport: function (sport) {
      let firstCategoryId = this.$store.state.trader.bettingBot
        ?.supportedSportsMap[sport.id].supportedCategories[0]?.id;
      let firstTournamentId = this.$store.state.trader.bettingBot
        ?.supportedSportsMap[sport.id].supportedCategoriesMap[firstCategoryId].supportedTournaments[0]?.id;
      this.$store.commit('setBotSport', sport.id);
      this.$store.commit('setBotCategory', firstCategoryId);
      this.$store.dispatch('getSupportedMarketsForBettingBot', firstTournamentId);
      this.$store.commit('setBotTournament', firstTournamentId);
    },
    selectCategory: function (category) {
      let firstTournamentId = this.$store.state.trader.bettingBot
        ?.supportedSportsMap[this.selectedSportData.id].supportedCategoriesMap[category.id].supportedTournaments[0]?.id;
      this.$store.commit('setBotCategory', category.id);
      this.$store.dispatch('getSupportedMarketsForBettingBot', firstTournamentId);
      this.$store.commit('setBotTournament', firstTournamentId);
    },
    selectTournament: function (tournament) {
      this.$store.dispatch('getSupportedMarketsForBettingBot', tournament.id);
      this.$store.commit('setBotTournament', tournament.id);
    },
    selectMarket: function (market) {
      if(market !== 'none'){
        this.$store.dispatch('getMarketBotConfig',market.id);
      } else {
        this.$store.commit('setBotConfig', 'none')

      }
      // this.$store.commit('setBotConfig', market);
    }
  },
  directives: {
    clickOutside: {
      componentUpdated: function (el, binding, vnode) {
        setTimeout(() => {
          const handler = (e) => {
            if (!el.contains(e.target) && el !== e.target && vnode.context.$data.dropdowns[binding.arg]) {
              binding.value(e);
            }
          };
          if (vnode.context.$data.dropdowns[binding.arg]) {
            if (vnode.context.$data._clickOutside[binding.arg] == null) {
              vnode.context.$data._clickOutside[binding.arg] = handler;
              document.addEventListener('click', vnode.context.$data._clickOutside[binding.arg]);
            }
          } else {
            document.removeEventListener('click', vnode.context.$data._clickOutside[binding.arg]);
            vnode.context.$data._clickOutside[binding.arg] = null;
          }
        }, 100);
      },
      unbind: function (el, binding, vnode) {
        document.removeEventListener('click', vnode.context.$data._clickOutside[binding.arg]);
        vnode.context.$data._clickOutside[binding.arg] = null;
      }
    }
  },
  mounted: function () {
    this.$store.dispatch('getBotSupportedMarkets');
    this.tempBotConfig = JSON.parse(JSON.stringify(this.selectedMarket));

  }
};
</script>

<style scoped>

  .betting-bot-dropdowns {
    padding: 0 8px 8px 8px;
    border-bottom: 1px solid var(--grey-200);
  }

  .positive-open-position {
    color: var(--aquaman);

  }

  .negative-open-position {
    color: var(--cyborg);

  }

  .reduced-seed {
    color: var(--wonder-woman);

  }

  .very-low-seed {
    color: var(--cyborg);
  }

  .empty-betslip {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
  }

  .empty-betslip-image {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 122px;
    max-height: 122px;
  }

  .empty-betslip-image > .v-icon {
    display: flex;
    align-items: center;
    max-width: 122px;
    max-height: 122px;
    font-size: 122px;
    color: var(--grey-300);
  }

  .empty-betslip-text {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
  }

  .empty-betslip-text > span {
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    color: var(--grey-400);
  }

  .place-bet-container {
    display: flex;
    flex-direction: column;
    position: fixed;
    bottom: 0;
    right: 0;
    width: 360px;
    box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.1) !important;
    z-index: 2;
    background: white;
  }

  .place-bet-amount-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 8px;
    border-bottom: 1px solid var(--grey-200);
  }

  .place-bet-amount-controls {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 8px;
    overflow: hidden;
  }

  .close-button {
    display: flex;
    align-items: center;
    padding: 8px 8px 8px 16px;
    cursor: pointer;
    height: max-content;
    overflow: hidden;
  }

  .close-button > span {
    line-height: 16px;
    font-size: 12px;
    font-weight: bold;
    color: var(--grey-400);
    text-transform: uppercase;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .close-button:hover > span {
    color: var(--grey-500);
  }

  .close-button--disabled {
    cursor: not-allowed;
  }

  .close-button.close-button--disabled:hover > span {
    color: var(--grey-400);
  }

  .footer-button-wrapper {
    max-width: 100%;
  }

  .footer-button {
    display: flex;
    flex-direction: row;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    margin-left: 8px;
  }

  .footer-button.footer-button--primary {
    background-color: var(--primary);
  }

  .footer-button.footer-button--grey {
    background-color: var(--grey-300);
  }

  .footer-button > .v-icon {
    font-size: 12px;
    line-height: 16px;
    animation: spin 1s infinite linear;
  }

  .footer-button.footer-button--primary:not(.footer-button-spinning):hover {
    background-color: var(--primary-state);
  }

  .footer-button.footer-button--grey:not(.footer-button-spinning):hover {
    background-color: var(--grey-300-state);
  }

  .footer-button.footer-button-spinning {
    cursor: default;
  }

  .footer-button > span {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
    text-transform: uppercase;
    font-weight: bold;
    text-transform: uppercase;
    width: 100%;
    white-space: nowrap;
  }

  .footer-button.footer-button--primary > span {
    color: white;
  }

  .footer-button.footer-button--grey > span {
    color: var(--grey-600);
  }

  .footer-button-text {
    padding-left: 8px;
  }

  .keep-in-play {
    display: flex;
    position: relative;
    align-items: center;
  }

  .keep-in-play-checkbox {
    margin-right: 6px;
    opacity: 0;
  }

  .place-bet-amount {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-left: 16px;
  }


  .place-bet-amount {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-left: 16px;
  }

  .place-bet-amount-desc {
    font-weight: bold;
    font-size: 10px;
    line-height: 14px;
    display: flex;
    align-items: center;
    text-align: right;
    color: var(--grey-400);
    margin-bottom: 2px;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .bet-amount {
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    color: var(--grey-900);
  }


  .betting-bot {
    display: flex;
    flex-direction: column;
    padding-bottom: 8px;
    width: 100%;
    overflow: auto;
    height: calc(100% - 48px);
    overscroll-behavior: contain;
  }

  .betting-bot-options {
    padding: 8px;
  }

  .betting-bot-state {
    display: flex;
    position: relative;
    align-items: center;
    overflow: hidden;
  }

  .betting-bot-state > span {
    font-size: 14px;
    line-height: 18px;
    color: var(--grey-500);
    overflow: hidden;
    /* let it wrap
    white-space: nowrap; */
    text-overflow: ellipsis;
  }

  .state-container .betting-bot-state > span {
    color: var(--grey-800);
  }

  .input-containers .betting-bot-state > span {
    font-size: 12px;
    line-height: 16px;
  }

  .betting-bot-checkbox {
    margin-right: 8px;
    opacity: 0;
    width: 16px;
    height: 16px;
  }

  .visible-betting-bot-checkbox {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    position: absolute;
    background-color: var(--grey-200);
    border: 1px solid var(--grey-300);
    box-sizing: border-box;
    border-radius: 2px;
    pointer-events: none;
    transition: border 0.2s ease-in-out;
  }

  .betting-bot-checkbox {
    cursor: pointer;
  }

  .betting-bot-checkbox--disabled {
    cursor: not-allowed;
  }

  .betting-bot-checkbox:not(.betting-bot-checkbox--disabled):hover ~ .visible-betting-bot-checkbox {
    border-color: var(--grey-400);
  }

  .betting-bot-checkbox:checked ~ .visible-betting-bot-checkbox {
    background-color: var(--primary);
    border-color: var(--primary-state);
  }

  .betting-bot-checkbox:not(.betting-bot-checkbox--disabled):checked:hover ~ .visible-betting-bot-checkbox {
    border-color: var(--superman-state);
  }

  .visible-betting-bot-checkbox > .v-icon {
    color: white;
    font-size: 14px;
    position: relative;
    display: none;
    pointer-events: none;
  }

  .betting-bot-checkbox:checked ~ .visible-betting-bot-checkbox > .v-icon {
    display: flex;

  }

  .dropdown-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;
    flex-direction: column;
  }

  .dropdown {
    display: flex;
    align-items: center;
    border: 1px solid var(--grey-300);
    border-radius: 4px;
    width: 100%;
    cursor: pointer;
    background-color: white;
  }

  .dropdown-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    margin-left: 4px;
  }

  .dropdown-text {
    display: flex;
    padding: 8px 0;
    user-select: none;
    overflow: hidden;
    margin-left: 8px;
  }

  .dropdown-icon ~ .dropdown-text {
    margin-left: 4px;
  }

  .dropdown-text > span {
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    color: var(--grey-800);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .dropdown-selection {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: calc(100% - 28px);
  }

  .dropdown-dropdown-arrow, .dropdown-dropdown-arrow > i {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
  }

  .dropdown-dropdown-arrow {
    margin-right: 4px;
    margin-left: 8px;
  }

  .dropdown-dropdown-arrow > i {
    font-size: 16px;
    color: var(--grey-900);
  }

  .dropdown-dropdown-arrow-open > i {
    transform: rotateZ(-180deg);
  }

  .dropdown-anchor {
    position: relative;
    width: 100%;
  }

  .dropdown-absolute {
    position: absolute;
    width: 100%;
    z-index: 10;
    top: 4px;
    transition: padding-top 0s 0.4s;
    background: white;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.19);
  }

  .dropdown-absolute-open {
    top: 4px;
    border-radius: 4px;
    overflow: hidden;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-right: 2px;
    transition: padding-top 0s;
  }

  .dropdown-contents::-webkit-scrollbar {
    width: 8px;
    background: #f0f0f0;
  }

  .dropdown-contents::-webkit-scrollbar-thumb {
    background: #c1c1c1;
  }

  .dropdown-contents::-webkit-scrollbar-thumb:hover {
    background: #a6a6a6;
  }

  .dropdown-contents {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    max-height: 0;
    width: 100%;
    overflow: hidden;
    flex-direction: column;
    transition: max-height 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);
    background: white;
    scrollbar-width: thin;
  }

  .dropdown-contents-open {
    overflow-x: hidden !important;
    overflow-y: auto !important;
    max-height: 200px;
  }

  .dropdown-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    transition: background-color 0.25s ease-in-out;
  }

  .dropdown-item:hover {
    background: var(--grey-200);
    cursor: pointer;
  }

  .dropdown-item-selection {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .dropdown-item-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    margin-left: 4px;
  }

  .dropdown-item-text {
    display: flex;
    padding: 8px 0;
    user-select: none;
    padding-right: 8px;
    margin-left: 8px;
  }

  .dropdown-item-icon ~ .dropdown-item-text {
    margin-left: 4px;
  }

  .dropdown-item-text > span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--grey-800);
  }

  .state-container {
    padding-top: 8px;
    padding-bottom: 8px;
    display: flex;
    justify-content: center;
  }

  .dropdown-container {
    display: flex;
    flex-direction: column;
    padding-top: 8px;
    width: 100%;
  }

  .dropdown-container--left {
    padding-right: 4px;
    width: 50%;
  }

  .dropdown-container--right {
    padding-left: 4px;
    width: 50%;
  }


  .dropdown-container-label {
    display: flex;
    align-items: center;
    padding-bottom: 1px;
  }

  .dropdown-container-label > span {
    font-size: 10px;
    line-height: 14px;
    color: var(--grey-500);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: bold;
    text-transform: uppercase;
  }

  .dropdown-absolute-sports {
    z-index: 10;
  }

  .dropdown-absolute-category {
    z-index: 9;
  }

  .dropdown-absolute-competition {
    z-index: 8;
  }

  .dropdown-absolute-market {
    z-index: 7;
  }

  .input-containers {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding-top: 0px;
  }

  .input-containers.input-containers--align-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-top: 8px;
  }

  .input-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    padding-top: 8px;
  }

  .input-container-dual-left {
    padding-right: 4px;
  }

  .input-container-dual-right {
    padding-left: 4px;
  }

  .input-label {
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
    margin-bottom: 1px;
  }

  .input-label > span {
    font-size: 10px;
    line-height: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    color: var(--grey-500);
    text-transform: uppercase;
  }

  .input-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-left: 8px;
    padding-right: 8px;
    border: 1px solid var(--grey-300);
    border-radius: 4px;
    background-color: var(--grey-100);
  }

  .input-wrapper:hover {
    border: 1px solid var(--grey-400);
  }

  .input-wrapper:focus-within {
    border: 1px solid var(--primary);
  }

  .input-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 8px 0;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    color: var(--grey-900);
    caret-color: var(--primary);
    height: 100%;
    max-height: 32px;
    text-align: center;
  }

  .input-inner::placeholder {
    color: var(--grey-400);
  }

  .input-inner:-ms-input-placeholder {
    color: var(--grey-400);
  }

  .input-inner::-ms-input-placeholder {
    color: var(--grey-400);
  }

  .input-inner:focus {
    outline: none;
  }

  .read-only-containers {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 0px;
  }

  .read-only-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    padding-top: 8px;
  }

  .read-only-container--left {
    padding-right: 4px;
  }

  .read-only-container--right {
    padding-left: 4px;
  }

  .read-only-label {
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
    margin-bottom: 1px;
  }

  .read-only-label > span {
    font-size: 10px;
    line-height: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    color: var(--grey-500);
    text-transform: uppercase;
  }

  .read-only-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-left: 8px;
    padding-right: 8px;
    background-color: var(--grey-100);
    border-radius: 4px;
  }

  .read-only-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 8px 0;
    font-size: 12px;
    line-height: 16px;
    color: var(--grey-900);
    height: 100%;
    max-height: 32px;
    font-weight: bold;
  }

  .input-inner:focus {
    outline: none;
  }

  @media screen and (max-width: 1279px) {
    .place-bet-container {
      position: absolute !important;
      width: 100%;
    }
  }

</style>
